
























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AjudaStore from '@/store/ajuda/AjudaStore'

@Component

export default class ViewAjuda extends Vue {
  get getAjudaStore() {
    return getModule(AjudaStore, this.$store)
  }

  get faqs() {
    return this.getAjudaStore.faqs
  }

  async mounted() {
    await this.getAjudaStore.getFaqs()
  }
}
